import { gql, useQuery } from "@apollo/client";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";
import mainPermissionList from "../../config/MainPermissionListConfig";

//Schema definition
const Q_GetWebMenuList = gql`
  query getWebMenuList($businessId: ID) {
    getWebMenuList(businessId: $businessId) {
      edges {
        node {
          id
          menuName
          codeInWeb
          webPosition
          webPriority
          icon
          educationalGuidance
          subMenus(ordering: "web_priority", device_In: ["وب", "هردو"]) {
            edges {
              node {
                educationalGuidance
                id
                name
                codeInWeb
                icon
                webPriority
              }
            }
          }
        }
      }
    }
  }
`;

function useGetWebMenuList(businessID) {
  const { requestConfig } = useRequestConfig();
  const { loading, error, data, refetch } = useQuery(
    Q_GetWebMenuList,
    requestConfig({
      module: "AVC_AAA",
      variables: {
        businessId: businessID,
      },
      Microservice: mainPermissionList.getWebMenuList,
    })
  );
  return { data, error, loading, refetch };
}
export default useGetWebMenuList;
